import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector).use(initReactI18next).init({
  debug: true,
  lng: "en",
  resources: {
    en: {
      "translation": {
        "Courses": "Courses",
        "MyCourses": "My Courses",
        "Categories": "Categories",
        "Instructor": "Instructor",
        "SearchHere": "Search here...",
        "MainQuote": "Learn In-Demand IT Skills with Expert-Led Online Courses",
        "SubQuote": "We proudly provide quality education at your hand.",
        "StartLearning": "Start Learning",
        "ExploringSkills": "Start your exploring skills here",
        "ChoosePlatform": "Choose our Platform for",
        "FeaturedCourses": "Featured Courses",
        "PreviousSearchedCourses": "Previous Searched Courses",
        "ExploreMore": "Explore More",
        "ExploreLess": "Explore Less",
        "Save": "Save",
        "FullName": "Full Name",
        "Email": "Email",
        "NewEmail": "New Email",
        "Home": "Home",
        "Instructors": "Instructors",
        "AboutUs": "About us",
        "ContactUs": "Contact Us",
        "Teams": "Teams",
        "PrivacyPolicy": "Privacy Policy",
        "CookingSettings": "Cooking Settings",
        "SiteMap": "Site map",
        "NoResultsFound": "No results found",
        "GoToMyCourses": "Go to My Courses",
        "AccountSettings": "Account Settings",
        "Signout": "Signout",
        "EnrolledCourses": "Enrolled Courses",
        "PersonalInfo": "Personal Info",
        "AccountSecurity": "Account Security",
        "CompletedCourses": "Completed Courses",
               "Note": "Note",
        "AIInterviewNote": "This certificate includes an AI-driven interview and coding questions if the course is based on programming languages. It demonstrates your readiness for technical assessments involving hands-on coding challenges and algorithmic problem-solving.",
        "Wishlist": "Wishlist",
        "PaymentHistory": "Payment History",
        "CurrentPassword": "Current Password",
        "NewPassword": "New Password",
        "ReTypeNewPassword": "Re-Type New Password",
        "MobileAppAuthenticator": "Mobile app authenticator",
        "UseMobileApp": "Use a mobile app for verification codes.",
        "ReceiveVerificationCode": "Receive verification code via email.",
        "Continue": "Continue",
        "PasswordUpdate": "Password Update",
        "TwoFASettings": "2FA Settings",
        "AccountActivityLog": "Account Activity Log",
        "CourseManagement": "Course Management",
        "StudentAnalytics": "Student Analytics",
        "EarningsOverview": "Earnings Overview",
        "CourseReviews": "Course Reviews",
        "Announcements": "Announcements",
        "SelectASection": "Select a section",
        "NewCourse": "+ New Course",
        "CourseName": "Course Name",
        "Description": "Description",
        "Price": "Price",
        "Action": "Action",
        "Earnings": "Earnings",
        "TrackYourEarnings": "Track your earnings and performance here.",
        "HideReport": "Hide Report",
        "ViewReport": "View Report",
        "YourEarningsReport": "Your Earnings Report",
        "TotalEarnings": "Total Earnings",
        "CoursesSold": "Courses Sold",
        "LastPayout": "Last Payout",
        "NextPayout": "Next Payout",
        "AddNewCourse": "Add New Course",
        "CourseAddedSuccess": "Course added successfully!",
        "CourseAddedFail": "Failed to add course.",
        "CourseAddError": "Error adding course.",
        "SelectCategory": "Select Category",
        "SelectSubcategory": "Select Subcategory",
        "SelectLevel": "Select Level",
        "SelectLanguage": "Select Language",
        "UploadThumbnail": "Upload Thumbnail",
        "Section": "Section",
        "SectionTitle": "Section Title",
        "VideoTitle": "Video Title",
        "AddLesson": "Add Lesson",
        "RemoveSection": "Remove Section",
        "AddAnotherSection": "Add Another Section",
        "AddCourse": "Add Course",
        "UploadingCourse": "Your course is being uploaded. Please wait a moment...",
        "QuizCreation": "Do you want to create a quiz?",
        "language": "English Courses",
        "MostSearchedCourses": "Most Searched Courses",
        "Message": "Message",
        "SendMessage": "Send Message",
        "Cart": "Cart",
        "OrderSummary": "Order Summary",
        "Items": "Items",
        "OrderValue": "Order Value",
        "GrandTotal": "Grand Total",
        "Checkout": "Check out",
        UploadingQuiz: "Uploading Quiz",
        QuizAddedSuccess: "Quiz added successfully!",
        QuizAddedFail: "Failed to add the quiz.",
        QuizAddError: "An error occurred while adding the quiz.",
        AddNewQuiz: "Add New Quiz",
        EnterYourQuestion: "Enter your question",
        Question: "Question",
        "Provide4AnswerOptions": "Provide 4 answer options (select one as correct):",
        "Answer": "Answer",
        Correct: "Correct",
        RemoveQuestion: "Remove Question",
        AddAnotherQuestion: "Add Another Question",
        AddQuiz: "Add Quiz",
        QuizUploadedSuccessfully: "Quiz Uploaded Successfully!",
        DoYouWantToGoHomePage: "Do you want to go to the home page?",
        GoHome: "Go Home",
        Language: "Language",
        Level: "Level",
        PriceRange: "Price Range",
        Rating: "Rating",
        ShowLess: "Show Less...",
        ShowMore: "Show More...",
        ClearFilters: "Clear Filters",
        ApplyFilters: "Apply Filters",
        MinPrice: "Min Price",
        MaxPrice: "Max Price",
        Close: "Close",
        SelectPriceRange: "Select a price range",
        SelectRating: "Select a rating",
        'SearchResultsfor': "Search Results for ",
        Total: "Total",
        Filters: "Filters",
        "Gotocart": "Go to cart",
        "languageCourse": "Courses in English",
        //new
        "Login": "Login",
        "Recommended Courses Based on Your Recent Completion: ": "Recommended Courses Based on Your Recent Completion: ",
        "Explore Courses Related to Your Recent Completion: ": "Explore Courses Related to Your Recent Completion: ",
        "You May Like These Courses After Completing: ": "You May Like These Courses After Completing: ",
        "Discover New Courses Based on Your Recent Completion: ": "Discover New Courses Based on Your Recent Completion: ",
        "Courses Suggested After Your Recent Completion: ": "Courses Suggested After Your Recent Completion: ",
        "CookieSettings": "Cookie Settings",
        "English": "English",
        "Recently Completed Courses": "Recently Completed Courses",
        "HelpMessage": "We are here for you! How can we help?",
        "SubjectPlaceholder": "Subject (issue)",
        "DescriptionPlaceholder": "Description",
        "SubmitButton": "Submit Ticket",
        "PaymentFailedTitle": "Payment Failed",
        "PaymentFailedMessage": "Please try again.",
        "RetryButton": "Retry",
        "PaymentSuccessTitle": "Payment Successful!",
        "PaymentSuccessMessage": "Your order has been placed successfully.",
        "GoToCoursesButton": "Go to Enrolled Courses",
        "Payment": "Payment",
        "TotalAmount": "Total Amount",
        "NoPaymentHistory": "No Payment History Found",
        "TransactionId": "Transaction ID",
        "Amount": "Amount",
        "Type": "Type",
        "Date": "Date",
        "NoCoursesEnrolled": "You have not enrolled in any courses.",
        "ViewCourse": "View Course",
        "SubmitSupportTicket": "Submit a Support Ticket",
        "Subject": "Subject",
        "SubmitTicket": "Submit Ticket",
        "YourSupportTickets": "Your Support Tickets",
        "NoTicketsFound": "No tickets found.",
        "Previous": "Previous",
        "Next": "Next",
        "Page": "Page",
        "Resolved": "Resolved ✔️",
        "Pending": "Pending ⌛",
        "Resolution": "Resolution",
        "Start Course": "Start Course",
        "AboutTheCertificate": "About the Certificate",
        "AfterCompletingCourse": "After completing a course, you will receive a digital certificate of completion.",
        "HowToGetIt": "How to Get It",
        "EnrollInCourse": "Enroll in any course of your choice. Upon completion, you will receive a certificate with a unique QR code. When scanned, the QR code will redirect to the Skillz Verse app, where your certificate can be viewed.",
        "DigitalFormat": "Digital Format",
        "CertificateInPdfFormat": "The certificate is available in PDF format, and you can easily download it once generated.",
        "WhyItIsImportant": "Why It’s Important",
        "ImportanceOfCertificate": "This certificate can help boost your resume, enhance your career prospects, and provide recognition of your skills and knowledge.",
        "SampleCertificate": "Sample Certificate",
        "CertificatePDF": "The certificate is available in PDF format, and you can easily download it.",
        "CertificateImportance": "This certificate can help boost your resume, enhance your career prospects, and provide recognition of your skills and knowledge.",
        "UponCompletion": "Upon completing the course, you will receive a digital certificate of completion.",
        "WhyImportant": "Why is this certificate important?",
        "Welcome back": "Welcome back",
        "Terms & Conditions": "Terms & Conditions",
        RefundPolicy: "Refund Policy",
        "Most Advanced Courses": "Most Advanced Courses",
        "Students": "Students",
        "Loading cart, please wait...": "Loading cart, please wait...",
        "YOUR BAG IS EMPTY": "YOUR BAG IS EMPTY",
        "There is nothing in your bag.": "There is nothing in your bag.",
        "Let's add something new to your collection": "Let's add something new to your collection",
        "No items in the cart": "No items in the cart",
        "Invalid course data": "Invalid course data",
        "Let’s Make Payment": "Let’s Make Payment",
        "Or login with": "Or login with",
        "Don’t have an account?": "Don’t have an account?",
        "I agree to the": "I agree to the",
        "Create account": "Create account",
        "Login to access your skillzverse account": "Login to access your skillzverse account",
        "Sign up": "Sign up",
        "Let’s get everything set up so you can access your personal account": "Let’s get everything set up so you can access your personal account",
        "Already have an account?": "Already have an account?",
        "Or Sign up with": "Or Sign up with",
        "Log In": "Log In",
        "Password": "Password",
        "Full Name": "Full Name",
        "Forgot your password?": "Forgot your password?",
        "Or Sign in with": "Or Sign in with",
        "Submit": "Submit",
        "Set password": "Set password",
        "OTP": "OTP",
        "Enter your email below to recover your password": "Enter your email below to recover your password",
        "Reset Password": "Reset Password",
        "Please create a new password for your account.": "Please create a new password for your account.",
        "Back to login": "Back to login",
        "Forgot Password": "Forgot Password",
        "Complete your learning journey—secure your spot now with a quick payment! Click below to proceed and unlock your next step to success.": "Complete your learning journey—secure your spot now with a quick payment! Click below to proceed and unlock your next step to success.",
        "Phone number": "Phone number",
        "Email or phone": "Email or Phone number",
        "Login with Password": "Login with Password",
        "Login with OTP": "Login with OTP",
        "Send OTP": "Send OTP",
        "Submit OTP": "Submit OTP",
        "Enter OTP": "Enter OTP",
        "NoCoursesCompleted": "You haven't completed any courses yet.",
        "AI Interview": "AI Interview",

      }
    }
    ,
    hi: {
      "translation": {
        "Courses": "कोर्स",
        "MyCourses": "मेरे कोर्स",
        "Categories": "श्रेणियाँ",
        "Instructor": "शिक्षक",
        "SearchHere": "यहाँ खोजें...",
        "MainQuote": "हर दिन नए कौशल ऑनलाइन सीखें।",
        "SubQuote": "हम गर्व से आपके हाथ में गुणवत्ता शिक्षा प्रदान करते हैं।",
        "StartLearning": "सीखना शुरू करें",
        "ExploringSkills": "यहाँ अपने कौशल का अन्वेषण करें।",
        "ChoosePlatform": "हमारे प्लेटफॉर्म का चयन करें",
        "FeaturedCourses": "विशेष कोर्स",
        "PreviousSearchedCourses": "पिछले खोजे गए कोर्स",
        "ExploreMore": "और अधिक अन्वेषण करें",
        "ExploreLess": "कम अन्वेषण करें",
        "Save": "सहेजें",
        "FullName": "पूरा नाम",
        "Email": "ईमेल",
        "NewEmail": "नया ईमेल",
        "Home": "मुख्य पृष्ठ",
        "Instructors": "शिक्षक",
        "AboutUs": "हमारे बारे में",
        "ContactUs": "संपर्क करें",
        "Teams": "टीमें",
        "PrivacyPolicy": "गोपनीयता नीति",
        "CookingSettings": "खाना पकाने की सेटिंग्स",
        "SiteMap": "साइट का नक्शा",
        "NoResultsFound": "कोई परिणाम नहीं मिला",
        "GoToMyCourses": "मेरे कोर्स पर जाएँ",
        "NoCoursesEnrolled": "कोई कोर्स नहीं है",
        "AccountSettings": "खाता सेटिंग्स",
        "Signout": "साइन आउट",
        "EnrolledCourses": "नामांकित कोर्स",
        "PersonalInfo": "व्यक्तिगत जानकारी",
        "AccountSecurity": "खाता सुरक्षा",
        "CompletedCourses": "पूर्ण कोर्स",
        "Wishlist": "इच्छा सूची",
        "PaymentHistory": "भुगतान इतिहास",
        "CurrentPassword": "वर्तमान पासवर्ड",
        "NewPassword": "नया पासवर्ड",
        "ReTypeNewPassword": "नया पासवर्ड फिर से टाइप करें",
        "MobileAppAuthenticator": "मोबाइल ऐप प्रमाणीकरण",
        "UseMobileApp": "प्रमाणन कोड के लिए मोबाइल ऐप का उपयोग करें।",
        "ReceiveVerificationCode": "ईमेल के माध्यम से सत्यापन कोड प्राप्त करें।",
        "Continue": "जारी रखें",
        "PasswordUpdate": "पासवर्ड अपडेट",
        "Welcome back": "स्वागत है वापस",
        "TwoFASettings": "2FA सेटिंग्स",
        "AccountActivityLog": "खाता गतिविधि लॉग",
        "CourseManagement": "कोर्स प्रबंधन",
        "StudentAnalytics": "छात्र विश्लेषण",
        "EarningsOverview": "आय का अवलोकन",
        "CourseReviews": "कोर्स समीक्षाएँ",
        "Announcements": "घोषणाएँ",
        "SelectASection": "एक अनुभाग चुनें",
        "NewCourse": "+ नया कोर्स",
        "CourseName": "कोर्स का नाम",
        "Description": "विवरण",
        "Price": "कीमत",
        "Action": "क्रिया",
        "Earnings": "आय",
        "TrackYourEarnings": "यहाँ अपनी आय और प्रदर्शन को ट्रैक करें।",
        "HideReport": "रिपोर्ट छिपाएँ",
        "ViewReport": "रिपोर्ट देखें",
        "YourEarningsReport": "आपकी आय रिपोर्ट",
        "TotalEarnings": "कुल आय",
        "CoursesSold": "बेचे गए कोर्स",
        "LastPayout": "अंतिम भुगतान",
        "NextPayout": "अगला भुगतान",
        "AddNewCourse": "नया कोर्स जोड़ें",
        "CourseAddedSuccess": "कोर्स सफलतापूर्वक जोड़ा गया!",
        "CourseAddedFail": "कोर्स जोड़ने में विफल।",
        "CourseAddError": "कोर्स जोड़ने में त्रुटि।",
        "SelectCategory": "श्रेणी चुनें",
        "SelectSubcategory": "उप श्रेणी चुनें",
        "SelectLevel": "स्तर चुनें",
        "SelectLanguage": "भाषा चुनें",
        "UploadThumbnail": "थंबनेल अपलोड करें",
        "Section": "अनुभाग",
        "SectionTitle": "अनुभाग का शीर्षक",
        "VideoTitle": "वीडियो का शीर्षक",
        "AddLesson": "पाठ जोड़ें",
        "RemoveSection": "अनुभाग हटाएँ",
        "AddAnotherSection": "एक और अनुभाग जोड़ें",
        "AddCourse": "कोर्स जोड़ें",
        "UploadingCourse": "आपका कोर्स अपलोड हो रहा है। कृपया एक पल प्रतीक्षा करें...",
        "QuizCreation": "क्या आप एक क्विज़ बनाना चाहते हैं?",
        "language": "अंग्रेजी कोर्स",
        "MostSearchedCourses": "सर्वाधिक खोजे गए कोर्स",
        "Message": "संदेश",
        "SendMessage": "संदेश भेजें",
        "Cart": "कार्ट",
        "OrderSummary": "आदेश सारांश",
        "Items": "आइटम",
        "OrderValue": "आदेश मूल्य",
        "GrandTotal": "कुल",
        "Checkout": "चेक आउट",
        "UploadingQuiz": "क्विज़ अपलोड हो रहा है",
        "QuizAddedSuccess": "क्विज़ सफलतापूर्वक जोड़ा गया!",
        "QuizAddedFail": "क्विज़ जोड़ने में विफल।",
        "QuizAddError": "क्विज़ जोड़ने में त्रुटि।",
        "AddNewQuiz": "नया क्विज़ जोड़ें",
        "EnterYourQuestion": "अपना प्रश्न दर्ज करें:",
        "Question": "प्रश्न",
        "Provide4AnswerOptions": "4 उत्तर विकल्प प्रदान करें (एक को सही के रूप में चुनें):",
        "Answer": "उत्तर",
        "Correct": "सही",
        "RemoveQuestion": "प्रश्न हटाएँ",
        "AddAnotherQuestion": "एक और प्रश्न जोड़ें",
        "AddQuiz": "क्विज़ जोड़ें",
        "QuizUploadedSuccessfully": "क्विज़ सफलतापूर्वक अपलोड हो गया!",
        "DoYouWantToGoHomePage": "क्या आप मुख्य पृष्ठ पर जाना चाहते हैं?",
        "GoHome": "मुख्य पृष्ठ पर जाएँ",
        "Language": "भाषा",
        "Level": "स्तर",
        "PriceRange": "मूल्य सीमा",
        "Rating": "रेटिंग",
        "ShowLess": "कम दिखाएँ...",
        "ShowMore": "और दिखाएँ...",
        "ClearFilters": "फ़िल्टर साफ़ करें",
        "ApplyFilters": "फ़िल्टर लागू करें",
        "MinPrice": "न्यूनतम मूल्य",
        "MaxPrice": "अधिकतम मूल्य",
        "Close": "बंद करें",
        "SelectPriceRange": "एक मूल्य सीमा चुनें",
        "SelectRating": "एक रेटिंग चुनें",
        "SearchResultsfor": "खोज परिणाम ",
        "Total": "कुल",
        "Filters": "फ़िल्टर",
        "Gotocart": "कार्ट पर जाएं",
        "languageCourse": "हिंदी में पाठ्यक्रम",
        "Login": "लॉगिन",
        "Recommended Courses Based on Your Recent Completion: ": "आपकी हाल की पूरी की गई कोर्स के आधार पर सुझाए गए कोर्स: ",
        "Explore Courses Related to Your Recent Completion: ": "आपकी हाल की पूरी की गई कोर्स से संबंधित कोर्स अन्वेषण करें: ",
        "You May Like These Courses After Completing: ": "आप इन कोर्सों को पूरा करने के बाद पसंद कर सकते हैं: ",
        "Discover New Courses Based on Your Recent Completion: ": "आपकी हाल की पूरी की गई कोर्स के आधार पर नए कोर्स खोजें: ",
        "Courses Suggested After Your Recent Completion: ": "आपकी हाल की पूरी की गई कोर्स के बाद सुझाए गए कोर्स: ",
        "CookieSettings": "कुकी सेटिंग्स",
        "English": "अंग्रेज़ी",
        "Recently Completed Courses": "हाल ही में पूर्ण किए गए कोर्स",
        "HelpMessage": "हम यहाँ आपकी सहायता के लिए हैं! हम आपकी कैसे मदद कर सकते हैं?",
        "SubjectPlaceholder": "विषय (समस्या)",
        "DescriptionPlaceholder": "विवरण",
        "SubmitButton": "टिकट सबमिट करें",
        "PaymentFailedTitle": "भुगतान विफल",
        "PaymentFailedMessage": "कृपया पुनः प्रयास करें।",
        "RetryButton": "पुनः प्रयास करें",
        "PaymentSuccessTitle": "भुगतान सफल!",
        "PaymentSuccessMessage": "आपका आदेश सफलतापूर्वक स्थानित किया गया है।",
        "GoToCoursesButton": "नामांकित कोर्स पर जाएं",
        "Payment": "भुगतान",
        "TotalAmount": "कुल राशि",
        "NoPaymentHistory": "कोई भुगतान इतिहास नहीं मिला",
        "TransactionId": "लेन-देन आईडी",
        "Amount": "राशि",
        "Type": "प्रकार",
        "Date": "तारीख",
        "ViewCourse": "कोर्स देखें",
        "SubmitSupportTicket": "सहायता टिकट सबमिट करें",
        "Subject": "विषय",
        "SubmitTicket": "टिकट सबमिट करें",
        "YourSupportTickets": "आपके सहायता टिकट",
        "NoTicketsFound": "कोई टिकट नहीं मिला।",
        "Previous": "पिछला",
        "Next": "अगला",
        "Page": "पृष्ठ",
        "Resolved": "समाधान ✔️",
        "Pending": "लंबित ⌛",
        "Resolution": "समाधान",
        "Start Course": "कोर्स शुरू करें",
        "AboutTheCertificate": "प्रमाणपत्र के बारे में",
        "AfterCompletingCourse": "कोर्स पूरा करने के बाद, आपको एक डिजिटल प्रमाणपत्र मिलेगा।",
        "HowToGetIt": "इसे कैसे प्राप्त करें",
        "EnrollInCourse": "किसी भी कोर्स में नामांकित करें। पूरा करने पर, आपको एक प्रमाणपत्र मिलेगा जिसमें एक अद्वितीय QR कोड होगा। जब स्कैन किया जाएगा, तो QR कोड Skillz Verse ऐप पर रीडायरेक्ट करेगा, जहाँ आपका प्रमाणपत्र देखा जा सकता है।",
        "DigitalFormat": "डिजिटल प्रारूप",
        "CertificateInPdfFormat": "प्रमाणपत्र PDF प्रारूप में उपलब्ध है, और आप इसे जनरेट होने के बाद आसानी से डाउनलोड कर सकते हैं।",
        "WhyItIsImportant": "यह क्यों महत्वपूर्ण है",
        "ImportanceOfCertificate": "यह प्रमाणपत्र आपके रिज़्यूमे को बढ़ावा देने में मदद कर सकता है, आपके करियर के अवसरों को बढ़ा सकता है, और आपके कौशल और ज्ञान की पहचान प्रदान कर सकता है।",
        "SampleCertificate": "नमूना प्रमाणपत्र",
        "CertificatePDF": "सर्टिफिकेट PDF फॉर्मेट में उपलब्ध है, और आप इसे आसानी से डाउनलोड कर सकते हैं।",
        "CertificateImportance": "यह सर्टिफिकेट आपके रिज़्यूमे को बढ़ाने, आपके करियर के अवसरों को सुधारने और आपके कौशल और ज्ञान को पहचान दिलाने में मदद कर सकता है।",
        "WhyImportant": "यह प्रमाणपत्र क्यों महत्वपूर्ण है?",
        "UponCompletion": "कोर्स पूरा करने के बाद, आपको एक डिजिटल प्रमाणपत्र प्राप्त होगा।",
        "Terms & Conditions": "नियम और शर्तें",
        RefundPolicy: "रिफंड नीति",
        "Most Advanced Courses": "सबसे उन्नत कोर्स",
        "Students": "विद्यार्थी",
        "Loading cart, please wait...": "कार्ट लोड हो रहा है, कृपया प्रतीक्षा करें...",
        "YOUR BAG IS EMPTY": "आपका बैग खाली है",
        "There is nothing in your bag.": "आपके बैग में कुछ नहीं है",
        "Let's add something new to your collection": "आइए, आपकी संग्रह में कुछ नया जोड़ते हैं",
        "No items in the cart": "कार्ट में कोई वस्तु नहीं है",
        "Invalid course data": "अमान्य कोर्स डेटा",
        "Let’s Make Payment": "आइए भुगतान करें",
        "Or login with": "या लॉगिन करें",
        "Don’t have an account?": "क्या आपका खाता नहीं है?",
        "I agree to the": "मैं सहमत हूं",
        "Create account": "खाता बनाएं",
        "Login to access your skillzverse account": "अपने skillzverse खाते में प्रवेश करने के लिए लॉगिन करें",
        "Sign up": "साइन अप करें",
        "Let’s get everything set up so you can access your personal account": "आइए, हम सब कुछ सेट करें ताकि आप अपने व्यक्तिगत खाते तक पहुंच सकें",
        "Already have an account?": "क्या आपके पास पहले से खाता है?",
        "Or Sign up with": "या साइन अप करें",
        "Log In": "लॉग इन करें",
        "Password": "पासवर्ड",
        "Full Name": "पूरा नाम",
        "Forgot your password?": "क्या आपने अपना पासवर्ड भूल गए?",
        "Or Sign in with": "या साइन इन करें",
        "Submit": "जमा करें",
        "Set password": "पासवर्ड सेट करें",
        "OTP": "ओटीपी",
        "Enter your email below to recover your password": "अपना पासवर्ड पुनर्प्राप्त करने के लिए नीचे अपना ईमेल दर्ज करें",
        "Reset Password": "पासवर्ड रीसेट करें",
        "Please create a new password for your account.": "कृपया अपने खाते के लिए नया पासवर्ड बनाएं",
        "Back to login": "लॉगिन पर वापस जाएं",
        "Forgot Password": "क्या आपने पासवर्ड भूल गए?",
        "Complete your learning journey—secure your spot now with a quick payment! Click below to proceed and unlock your next step to success.": "अपनी सीखने की यात्रा पूरी करें—त्वरित भुगतान के साथ अपनी जगह अब सुरक्षित करें! आगे बढ़ने के लिए नीचे क्लिक करें और सफलता की दिशा में अपना अगला कदम अनलॉक करें।",
        "Phone number": "फोन नंबर",

        "Email or phone": "ईमेल या फोन नंबर",
        "Login with Password": "पासवर्ड के साथ लॉगिन करें",
        "Login with OTP": "ओटीपी के साथ लॉगिन करें",
        "Send OTP": "ओटीपी भेजें",
        "Submit OTP": "ओटीपी सबमिट करें",
        "Enter OTP": "ओटीपी दर्ज करें",
        "AI Interview": "AI इंटरव्यू",
        "NoCoursesCompleted": "आपने अभी तक कोई कोर्स पूरा नहीं किया है।",
      }
    }
    ,
    te: {
      "translation": {
        "Courses": "పాఠ్యక్రమాలు",
        "MyCourses": "నా పాఠ్యక్రమాలు",
        "Categories": "వర్గాలు",
        "Instructor": "ఉపాధ్యాయుడు",
        "SearchHere": "ఇక్కడ వెదుకండి...",
        "MainQuote": "ప్రతి రోజు కొత్త నైపుణ్యాలను ఆన్లైన్‌లో నేర్చుకోండి.",
        "SubQuote": "మీ చేతిలో నాణ్యమైన విద్యను గర్వంగా అందిస్తున్నాము.",
        "StartLearning": "అన్వేషణ ప్రారంభించండి",
        "ExploringSkills": "ఇక్కడ మీ నైపుణ్యాలను అన్వేషించండి.",
        "ChoosePlatform": "మా ప్లాట్‌ఫామ్‌ను ఎంచుకోండి",
        "FeaturedCourses": "ఫీచర్ చేసిన కోర్సులు",
        "PreviousSearchedCourses": "మునుపటి వెదికిన కోర్సులు",
        "ExploreMore": "మరింత అన్వేషించండి",
        "ExploreLess": "చిన్నగా అన్వేషించండి",
        "Save": "సేవ్",
        "FullName": "పూర్తి పేరు",
        "Email": "ఈమెయిల్",
        "NewEmail": "కొత్త ఈమెయిల్",
        "Home": "హోమ్",
        "Instructors": "ఉపాధ్యాయులు",
        "AboutUs": "మన గురించి",
        "ContactUs": "మా సంప్రదించండి",
        "Teams": "టీమ్స్",
        "PrivacyPolicy": "గోప్యతా విధానం",
        "CookingSettings": "ఉప్పు కూరకు సెట్ చేయండి",
        "SiteMap": "సైట్ మాప్",
        "NoResultsFound": "కోئی ఫలితాలు లేవు",
        "GoToMyCourses": "నా పాఠ్యక్రమాలకు వెళ్ళండి",
        "NoCoursesEnrolled": "ఏ కోర్సు నమోదు చేయబడలేదు",
        "AccountSettings": "ఖాతా సెటింగ్స్",
        "Signout": "సైన్ అవుట్",
        "EnrolledCourses": "నమోదైన కోర్సులు",
        "PersonalInfo": "వ్యక్తిగత సమాచారం",
        "AccountSecurity": "ఖాతా భద్రత",
        "CompletedCourses": "పూర్తి చేసిన కోర్సులు",
        "Wishlist": "ఇష్టమైనవి",
        "PaymentHistory": "చెల్లింపు చరిత్ర",
        "CurrentPassword": "ప్రస్తుత పాస్వర్డ్",
        "NewPassword": "కొత్త పాస్వర్డ్",
        "ReTypeNewPassword": "కొత్త పాస్వర్డ్‌ను రీటైప్ చేయండి",
        "MobileAppAuthenticator": "మొబైల్ యాప్ ధ్రువీకర్త",
        "UseMobileApp": "ధ్రువీకరణ కోడ్స్ కోసం మొబైల్ యాప్‌ని ఉపయోగించండి.",
        "ReceiveVerificationCode": "ఈమెయిల్ ద్వారా ధ్రువీకరణ కోడ్‌ను పొందండి.",
        "Continue": "కొనసాగించండి",
        "PasswordUpdate": "పాస్వర్డ్ నవీకరణ",
        "TwoFASettings": "2FA సెటింగ్స్",
        "AccountActivityLog": "ఖాతా కార్యకలాపాలు",
        "CourseManagement": "కోర్సు నిర్వహణ",
        "StudentAnalytics": "విద్యార్థి విశ్లేషణ",
        "EarningsOverview": "లాభాల సమీక్ష",
        "CourseReviews": "కోర్సు సమీక్షలు",
        "Announcements": "ప్రకటనలు",
        "SelectASection": "ఒక విభాగాన్ని ఎంచుకోండి",
        "NewCourse": "+ కొత్త కోర్సు",
        "CourseName": "కోర్సు పేరు",
        "Description": "వివరణ",
        "Price": "ధర",
        "Action": "చర్య",
        "Earnings": "లాభాలు",
        "TrackYourEarnings": "మీ లాభాలను మరియు పనితీరును ఇక్కడ ట్రాక్ చేయండి.",
        "HideReport": "రిపోర్ట్ దాచండి",
        "ViewReport": "రిపోర్ట్ చూడండి",
        "YourEarningsReport": "మీ లాభాల రిపోర్ట్",
        "TotalEarnings": "మొత్తం లాభాలు",
        "CoursesSold": "అమ్మకాల కోర్సులు",
        "LastPayout": "చివరి చెల్లింపు",
        "NextPayout": "తరువాత చెల్లింపు",
        "AddNewCourse": "కొత్త కోర్సు జోడించండి",
        "CourseAddedSuccess": "కోర్సు విజయవంతంగా జోడించబడింది!",
        "CourseAddedFail": "కోర్సు జోడించడంలో విఫలమైంది.",
        "CourseAddError": "కోర్సు జోడించడంలో పొరపాటు.",
        "SelectCategory": "వర్గం ఎంచుకోండి",
        "SelectSubcategory": "ఉపవర్గం ఎంచుకోండి",
        "SelectLevel": "స్థాయి ఎంచుకోండి",
        "SelectLanguage": "భాష ఎంచుకోండి",
        "UploadThumbnail": "థంబ్నెయిల్ అప్లోడ్ చేయండి",
        "Section": "విభాగం",
        "SectionTitle": "విభాగం శీర్షిక",
        "VideoTitle": "వీడియో శీర్షిక",
        "AddLesson": "పాఠాన్ని జోడించండి",
        "RemoveSection": "విభాగాన్ని తీసేయండి",
        "AddAnotherSection": "మరొక విభాగం జోడించండి",
        "AddCourse": "కోర్సు జోడించండి",
        "UploadingCourse": "మీ కోర్సు అప్లోడ్ అవుతోంది. దయచేసి వేచి ఉండండి...",
        "QuizCreation": "మీరు ఒక క్విజ్ సృష్టించాలనుకుంటున్నారా?",
        "language": "ఆంగ్ల కోర్సు",
        "MostSearchedCourses": "అత్యధికంగా వెతికిన కోర్సులు",
        "Message": "సందేశం",
        "SendMessage": "సందేశం పంపండి",
        "Cart": "కార్టు",
        "OrderSummary": "ఆర్డర్ సమ్మరి",
        "Items": "సామాను",
        "OrderValue": "ఆర్డర్ విలువ",
        "GrandTotal": "మొత్తం",
        "Checkout": "చెక్కౌట్",
        "UploadingQuiz": "క్విజ్ అప్లోడ్ అవుతోంది",
        "QuizAddedSuccess": "క్విజ్ విజయవంతంగా జోడించబడింది!",
        "QuizAddedFail": "క్విజ్ జోడించడంలో విఫలమైంది.",
        "QuizAddError": "క్విజ్ జోడించడంలో పొరపాటు.",
        "AddNewQuiz": "కొత్త క్విజ్ జోడించండి",
        "EnterYourQuestion": "మీ ప్రశ్నను నమోదు చేయండి:",
        "Question": "ప్రశ్న",
        "Provide4AnswerOptions": "4 సమాధాన ఎంపికలను అందించండి (ఒకటిని సరైనది‌గా ఎంచుకోండి):",
        "Answer": "సమాధానం",
        "Correct": "సరైనది",
        "RemoveQuestion": "ప్రశ్నను తీసేయండి",
        "AddAnotherQuestion": "మరొక ప్రశ్న జోడించండి",
        "AddQuiz": "క్విజ్ జోడించండి",
        "QuizUploadedSuccessfully": "క్విజ్ విజయవంతంగా అప్లోడ్ చేయబడింది!",
        "DoYouWantToGoHomePage": "మీరు హోమ్ పేజీకి వెళ్లాలనుకుంటున్నారా?",
        "GoHome": "హోమ్ పేజీకి వెళ్లండి",
        "Language": "భాష",
        "Level": "స్థాయి",
        "PriceRange": "ధర పరిధి",
        "Rating": "రేటింగ్",
        "ShowLess": "కన్నా తక్కువ చూపించు...",
        "ShowMore": "మరింత చూపించు...",
        "ClearFilters": "ఫిల్టర్లు క్లియర్ చేయండి",
        "ApplyFilters": "ఫిల్టర్లు అప్లై చేయండి",
        "MinPrice": "కనిష్ట ధర",
        "MaxPrice": "గరిష్ట ధర",
        "Close": "మూసివేయండి",
        "SelectPriceRange": "ఒక ధర పరిధిని ఎంచుకోండి",
        "SelectRating": "ఒక రేటింగ్‌ను ఎంచుకోండి",
        "SearchResultsfor": "శోధన ఫలితాలు ",
        "Total": "మొత్తం",
        "Filters": "ఫిల్టర్లు",
        "Gotocart": "కార్టుకు వెళ్లండి",
        "languageCourse": "తెలుగులో కోర్సులు",
        "Login": "లాగిన్",
        "Recommended Courses Based on Your Recent Completion: ": "మీ ఇటీవల పూర్తి చేసిన కోర్సుల ఆధారంగా సిఫారసు చేసిన కోర్సులు: ",
        "Explore Courses Related to Your Recent Completion: ": "మీ ఇటీవల పూర్తి చేసిన కోర్సులకు సంబంధించిన కోర్సులు: ",
        "You May Like These Courses After Completing: ": "మీరు ఈ కోర్సులను పూర్తి చేసిన తర్వాత ఇష్టపడవచ్చు: ",
        "Discover New Courses Based on Your Recent Completion: ": "మీ ఇటీవల పూర్తి చేసిన కోర్సుల ఆధారంగా కొత్త కోర్సులను కనుగొనండి: ",
        "Courses Suggested After Your Recent Completion: ": "మీ గతంలో పూర్తి చేసిన కోర్సుల ఆధారంగా సూచించిన కోర్సులు: ",
        "CookieSettings": "కుకీ సెట్టింగులు",
        "English": "ఆంగ్లం",
        "Recently Completed Courses": "ఇటీవల పూర్తి చేసిన కోర్సులు",
        "HelpMessage": "మేము మీ కోసం ఇక్కడ ఉన్నాము! ఎలా సహాయం చేయగలం?",
        "SubjectPlaceholder": "విషయం",
        "DescriptionPlaceholder": "వివరణ",
        "SubmitButton": "టికెట్ సమర్పించండి",
        "PaymentFailedTitle": "చెల్లింపు విఫలమైంది",
        "PaymentFailedMessage": "దయచేసి మళ్లీ ప్రయత్నించండి.",
        "RetryButton": "మళ్లీ ప్రయత్నించండి",
        "PaymentSuccessTitle": "చెల్లింపు విజయవంతం!",
        "PaymentSuccessMessage": "మీ ఆర్డర్ విజయవంతంగా పూర్తి అయింది.",
        "GoToCoursesButton": "కోర్సుల పేజీకి వెళ్లండి",
        "Payment": "చెల్లింపు",
        "TotalAmount": "మొత్తం",
        "NoPaymentHistory": "చెల్లింపు చరిత్ర లేదు",
        "TransactionId": "వ్యవహార ID",
        "Amount": "మొత్తం",
        "Type": "రకం",
        "Welcome back": "మళ్ళీ స్వాగతం",
        "Date": "తేదీ",
        "ViewCourse": "కోర్సు చూడండి",
        "SubmitSupportTicket": "సహాయం టికెట్ సమర్పించండి",
        "Subject": "విషయం",
        "SubmitTicket": "టికెట్ సమర్పించండి",
        "YourSupportTickets": "మీ సహాయం టికెట్లు",
        "NoTicketsFound": "టికెట్లు లేవు.",
        "Previous": "మునుపటి",
        "Next": "తదుపరి",
        "Page": "పేజీ",
        "Resolved": "పరిష్కరించబడింది ✔️",
        "Pending": "పెండింగ్ ⌛",
        "Resolution": "పరిష్కారం",
        "Start Course": "ప్రారంభించండి",
        "AboutTheCertificate": "సర్టిఫికేట్ గురించి",
        "AfterCompletingCourse": "ఒక కోర్సు పూర్తి చేసిన తర్వాత, మీరు డిజిటల్ సర్టిఫికేట్ పొందుతారు.",
        "HowToGetIt": "ఇది ఎలా పొందాలి",
        "EnrollInCourse": "మీరు ఎంచుకున్న ఏ కోర్సులోనైనా నమోదు చేసుకోండి.",
        "UponCompletion": "పూర్తి చేసిన తర్వాత, మీరు ఒక ప్రత్యేక QR కోడ్‌తో సర్టిఫికేట్ పొందుతారు. ఈ QR కోడ్‌ను స్కాన్ చేసినప్పుడు, అది Skillz Verse యాప్‌లోకి మారుతుంది, అక్కడ మీరు మీ సర్టిఫికేట్‌ను చూడవచ్చు.",
        "DigitalFormat": "డిజిటల్ ఫార్మాట్",
        "CertificatePDF": "సర్టిఫికేట్ PDF ఫార్మాట్‌లో అందుబాటులో ఉంటుంది, మరియు మీరు సులభంగా డౌన్‌లోడ్ చేసుకోవచ్చు.",
        "WhyImportant": "ఇది ముఖ్యమా?",
        "CertificateImportance": "ఈ సర్టిఫికేట్ మీ రెస్యూమేను పెంచేందుకు, మీ కెరీర్ అవకాశాలను మెరుగుపరచడంలో మరియు మీ నైపుణ్యాలు మరియు జ్ఞానం గుర్తింపును పొందడంలో సహాయపడుతుంది.",
        "SampleCertificate": "నమూనా సర్టిఫికేట్",
        "Terms & Conditions": "విధి మరియు షరతులు",
        RefundPolicy: "రిఫండ్ పాలసీ",
        "Most Advanced Courses": "చాలా అభివృద్ధి చెందిన పాఠ్యక్రమాలు",
        "Students": "విద్యార్థులు",
        "Loading cart, please wait...": "కార్టు లోడ్ అవుతుంది, దయచేసి వేచి ఉండండి...",
        "YOUR BAG IS EMPTY": "మీ బాగ్ ఖాళీగా ఉంది",
        "There is nothing in your bag.": "మీ బాగ్ లో ఏమి లేదు",
        "Let's add something new to your collection": "మీ సేకరణలో కొత్తదాన్ని జోడించిద్దాం",
        "No items in the cart": "కార్ట్ లో ఎటువంటి వస్తువులు లేవు",
        "Invalid course data": "చెల్లని కోర్సు డేటా",
        "Let’s Make Payment": "చెల్లింపును చేయండి",
        "Or login with": "లాగిన్ చేయండి లేదా",
        "Don’t have an account?": "కరస్పాండి లేదు?",
        "I agree to the": "నేను అంగీకరించాను",
        "Create account": "ఖాతా సృష్టించండి",
        "Login to access your skillzverse account": "మీ skillzverse ఖాతా కోసం లాగిన్ చేయండి",
        "Sign up": "సైన్ అప్",
        "Let’s get everything set up so you can access your personal account": "మీ వ్యక్తిగత ఖాతా యాక్సెస్ చేసేందుకు అన్నీ సెట్ చేసుకుందాం",
        "Already have an account?": "ముందు ఖాతా ఉందా?",
        "Or Sign up with": "లేదా సైన్ అప్ చేయండి",
        "Log In": "లాగిన్",
        "Password": "పాస్‌వర్డ్",
        "Full Name": "పూర్తి పేరు",
        "Forgot your password?": "మీ పాస్‌వర్డ్ మర్చిపోయారా?",
        "Or Sign in with": "లేదా సైన్ ఇన్ చేయండి",
        "Submit": "సమర్పించండి",
        "Set password": "పాస్‌వర్డ్ సెట్ చేయండి",
        "OTP": "ఓటీపీ",
        "Enter your email below to recover your password": "మీ పాస్‌వర్డ్‌ను తిరిగి పొందడానికి మీ ఇమెయిల్‌ను క్రింద నమోదు చేయండి",
        "Reset Password": "పాస్‌వర్డ్ రీసెట్ చేయండి",
        "Please create a new password for your account.": "మీ ఖాతా కోసం కొత్త పాస్‌వర్డ్‌ని సృష్టించండి",
        "Back to login": "లాగిన్‌కు తిరిగి వెళ్ళండి",
        "Forgot Password": "మీ పాస్‌వర్డ్ మర్చిపోయారా?",
        "Complete your learning journey—secure your spot now with a quick payment! Click below to proceed and unlock your next step to success.": "మీ అభ్యాస ప్రయాణాన్ని పూర్తి చేయండి—ఒక తక్షణ పేమెంట్‌తో మీ స్థలాన్ని ఇప్పుడే సురక్షితం చేసుకోండి! కొనసాగించడానికి క్రింద క్లిక్ చేయండి మరియు విజయానికి మీ తదుపరి అడుగును అన్‌లాక్ చేయండి.",
        "Email or phone": "ఇమెయిల్ లేదా ఫోన్ నెంబర్",

        "Phone number": "ఫోన్ నెంబర్",
        "Login with Password": "పాస్వర్డ్ తో లాగిన్ అవ్వండి",
        "Login with OTP": "ఓటీపీతో లాగిన్ అవ్వండి",
        "Send OTP": "ఓటీపీ పంపండి",
        "Submit OTP": "ఓటీపీ సమర్పించండి",
        "Enter OTP": "ఓటీపీ నమోదు చేయండి",
        "NoCoursesCompleted": "మీరు ఇప్పటి వరకు ఏ కోర్సు కూడా పూర్తిగా చేయలేదు.",
        "AI Interview": "AI ఇంటర్వ్యూ",

      }
    }
    ,
    ta: {
      "translation": {
        "Courses": "கோடுகள்",
        "MyCourses": "எனது கோடுகள்",
        "Categories": "வகைகள்",
        "Instructor": "ஆசிரியர்",
        "SearchHere": "இங்கே தேடுங்கள்...",
        "MainQuote": "ஒவ்வொரு நாளும் புதிய திறன்கள் கற்றுக்கொள்கிறேன்.",
        "SubQuote": "நாங்கள் தரமான கல்வி வழங்குகிறோம்.",
        "StartLearning": "கற்றுகொண்டுவரும்",
        "ExploringSkills": "இங்கே உங்கள் திறன்களை ஆராயுங்கள்.",
        "ChoosePlatform": "எங்கள் தளத்தைத் தேர்ந்தெடுக்கவும்",
        "FeaturedCourses": "சிறப்பாகக் குறிப்பிடப்பட்ட கோடுகள்",
        "PreviousSearchedCourses": "முந்தைய தேடப்பட்ட கோடுகள்",
        "ExploreMore": "மேலும் ஆராயுங்கள்",
        "ExploreLess": "குறைவாக ஆராயுங்கள்",
        "Save": "சேமிக்கவும்",
        "FullName": "முழு பெயர்",
        "Email": "மின்னஞ்சல்",
        "Welcome back": "சுவாகதம்",
        "NewEmail": "புதிய மின்னஞ்சல்",
        "Home": "வீடு",
        "Instructors": "ஆசிரியர்கள்",
        "AboutUs": "எங்களைப் பற்றி",
        "ContactUs": "எங்களை அணுகவும்",
        "Teams": "அணிகள்",
        "PrivacyPolicy": "தனியுரிமை கொள்கை",
        "CookingSettings": "சமைக்கும் அமைப்புகள்",
        "SiteMap": "இணையம் வரைபடம்",
        "NoResultsFound": "எந்த முடிவும் கிடைக்கவில்லை",
        "GoToMyCourses": "என் கோடுகளுக்குச் செல்லவும்",
        "NoCoursesEnrolled": "பொதுவாகக் கல்வி இல்லை",
        "AccountSettings": "கணக்கு அமைப்புகள்",
        "Signout": "வெளியேறு",
        "EnrolledCourses": "எழுதிய கோடுகள்",
        "PersonalInfo": "தனிப்பட்ட தகவல்",
        "AccountSecurity": "கணக்கு பாதுகாப்பு",
        "CompletedCourses": "முடித்த கோடுகள்",
        "Wishlist": "விருப்பப்பட்டவை",
        "PaymentHistory": "சரியான பில்லிங்",
        "CurrentPassword": "தற்போதைய கடவுச்சொல்",
        "NewPassword": "புதிய கடவுச்சொல்",
        "ReTypeNewPassword": "புதிய கடவுச்சொல்லை மீண்டும் டைப் செய்க",
        "MobileAppAuthenticator": "மொபைல் பயன்பாடு சான்றளிப்பு",
        "UseMobileApp": "சான்றிதழ் குறியீடுகளுக்கு மொபைல் பயன்பாட்டைப் பயன்படுத்தவும்.",
        "ReceiveVerificationCode": "மின்னஞ்சலில் சான்றீப்பதிகையைப் பெறவும்.",
        "Continue": "தொடருங்கள்",
        "PasswordUpdate": "கடவுச்சொல் புதுப்பிப்பு",
        "TwoFASettings": "2FA அமைப்புகள்",
        "AccountActivityLog": "கணக்கு செயல்பாட்டுப் பதிவு",
        "CourseManagement": "கோடுகள் மேலாண்மை",
        "StudentAnalytics": "மாணவர்கள் விநியோகம்",
        "EarningsOverview": "உங்களது வருமானம்",
        "CourseReviews": "கோடுகள் விமர்சனம்",
        "Announcements": "அறிக்கைகள்",
        "SelectASection": "ஒரு பிரிவைத் தேர்ந்தெடுக்கவும்",
        "NewCourse": "+ புதிய கோட்",
        "CourseName": "கோட்டின் பெயர்",
        "Description": "விவரம்",
        "Price": "விலை",
        "Action": "செயல்",
        "Earnings": "வருமானம்",
        "TrackYourEarnings": "உங்கள் வருமானத்தை மற்றும் செயல்திறனை இங்கே கண்காணிக்கவும்.",
        "HideReport": "அறிக்கையை மறைக்கவும்",
        "ViewReport": "அறிக்கையைப் பார்க்கவும்",
        "YourEarningsReport": "உங்கள் வருமானம்",
        "TotalEarnings": "மொத்த வருமானம்",
        "CoursesSold": "விற்பனைக்கான கோடுகள்",
        "LastPayout": "கடைசி பணம்",
        "NextPayout": "அடுத்த பணம்",
        "AddNewCourse": "புதிய கோட் சேர்க்கவும்",
        "CourseAddedSuccess": "கோட் வெற்றிகரமாக சேர்க்கப்பட்டது!",
        "CourseAddedFail": "கோட் சேர்க்கும் போது தோல்வி.",
        "CourseAddError": "கோட் சேர்க்கும் போது பிழை.",
        "SelectCategory": "வகை தேர்ந்தெடுக்கவும்",
        "SelectSubcategory": "உபவகை தேர்ந்தெடுக்கவும்",
        "SelectLevel": "அடிப்படையை தேர்ந்தெடுக்கவும்",
        "SelectLanguage": "மொழியை தேர்ந்தெடுக்கவும்",
        "UploadThumbnail": "தொகுப்பு உருவத்தை பதிவேற்றவும்",
        "Section": "பிரிவு",
        "SectionTitle": "பிரிவின் தலைப்பு",
        "VideoTitle": "வீடியோ தலைப்பு",
        "AddLesson": "பாடத்தைச் சேர்க்கவும்",
        "RemoveSection": "பிரிவைப் பிறகு",
        "AddAnotherSection": "மற்றொரு பிரிவைப் சேர்க்கவும்",
        "AddCourse": "கோட் சேர்க்கவும்",
        "UploadingCourse": "உங்கள் கோட்டை பதிவேற்றுகிறது. தயவுசெய்து சில நிமிடங்கள் காத்திருங்கள்...",
        "QuizCreation": "நீங்கள் ஒரு க்விஜ் உருவாக்க விரும்புகிறீர்களா?",
        "MostSearchedCourses": "மிகவும் தேடப்பட்ட கோடுகள்",
        "Message": "செய்தி",
        "SendMessage": "செய்தி அனுப்பவும்",
        "Cart": "கார்ட்",
        "OrderSummary": "ஆர்டர் சுருக்கம்",
        "Items": "பொருட்கள்",
        "OrderValue": "ஆர்டர் மதிப்பு",
        "GrandTotal": "மொத்தம்",
        "Checkout": "செக்கவுட்",
        "UploadingQuiz": "க்விஜ் பதிவேற்றுகிறது",
        "QuizAddedSuccess": "க்விஜ் வெற்றிகரமாக சேர்க்கப்பட்டது!",
        "QuizAddedFail": "க்விஜ் சேர்க்கப்படுவதில் தோல்வி.",
        "QuizAddError": "க்விஜ் சேர்க்கும் போது பிழை.",
        "AddNewQuiz": "புதிய க்விஜ் சேர்க்கவும்",
        "EnterYourQuestion": "உங்கள் கேள்வியை உள்ளிடவும்",
        "Question": "கேள்வி",
        "Provide4AnswerOptions": "4 பதில் விருப்பங்களை வழங்கவும் (ஒரு பதிலை சரியானதாக தெரிவுசெய்க):",
        "Answer": "பதில்",
        "Correct": "சரியான",
        "RemoveQuestion": "கேள்வியை அகற்று",
        "AddAnotherQuestion": "மற்றொரு கேள்வியைச் சேர்க்கவும்",
        "AddQuiz": "க்விஜ் சேர்க்கவும்",
        "QuizUploadedSuccessfully": "க்விஜ் வெற்றிகரமாக பதிவேற்றப்பட்டது!",
        "DoYouWantToGoHomePage": "நீங்கள் முதன்மை பக்கத்திற்கு செல்ல விரும்புகிறீர்களா?",
        "GoHome": "முதன்மை பக்கத்திற்கு செல்லவும்",
        "Language": "மொழி",
        "Level": "அடிப்படை",
        "PriceRange": "விலை அளவுகோல்",
        "Rating": "ரேட்டிங்",
        "ShowLess": "குறைவாகக் காண்பி...",
        "ShowMore": "மேலும் காண்பி...",
        "ClearFilters": "வடிகட்டிகளை அழிக்கவும்",
        "ApplyFilters": "வடிகட்டிகளை செயல்படுத்தவும்",
        "MinPrice": "குறிப்பிட்ட விலை",
        "MaxPrice": "அதிக விலை",
        "Close": "மூடு",
        "SelectPriceRange": "ஒரு விலை அளவுகோலைத் தேர்ந்தெடுக்கவும்",
        "SelectRating": "ஒரு ரேட்டிங்கைத் தேர்ந்தெடுக்கவும்",
        "SearchResultsfor": "தேடல் முடிவுகள் ",
        "Total": "மொத்தம்",
        "Filters": "வடிகட்டிகள்",
        "Gotocart": "கார்ட்டிற்கு செல்லவும்",
        "languageCourse": "தமிழில் கோட்",
        "Login": "உள்நுழைய",
        "Recommended Courses Based on Your Recent Completion: ": "உங்கள் சமீபத்திய முடிக்கப்பட்ட படிப்புகளின் அடிப்படையில் பரிந்துரைக்கப்பட்ட படிப்புகள்: ",
        "Explore Courses Related to Your Recent Completion: ": "உங்கள் சமீபத்திய முடிக்கப்பட்ட படிப்புகளுக்கு தொடர்புடைய படிப்புகளை ஆராயவும்: ",
        "You May Like These Courses After Completing: ": "இந்த படிப்புகளை நீங்கள் முடித்த பிறகு விரும்பலாம்: ",
        "Discover New Courses Based on Your Recent Completion: ": "உங்கள் சமீபத்திய முடிக்கப்பட்ட படிப்புகளின் அடிப்படையில் புதிய படிப்புகளை கண்டறியவும்: ",
        "Courses Suggested After Your Recent Completion: ": "உங்கள் சமீபத்திய முடிக்கப்பட்ட படிப்புகளுக்கு பிறகு பரிந்துரைக்கப்பட்ட படிப்புகள்: ",
        "CookieSettings": "குக்கி அமைப்புகள்",
        "English": "ஆங்கிலம்",
        "Recently Completed Courses": "சமீபத்தில் முடிக்கப்பட்ட படிப்புகள்",
        "HelpMessage": "நாம் உங்கள் உதவிக்கு உள்ளே! எவ்வாறு உதவலாம்?",
        "SubjectPlaceholder": "பொருள் (பிரச்சனை)",
        "DescriptionPlaceholder": "விவரணம்",
        "SubmitButton": "டிக்கெட் சமர்ப்பி",
        "PaymentFailedTitle": "பணம் செலுத்தல் தோல்வி",
        "PaymentFailedMessage": "மீண்டும் முயற்சிக்கவும்.",
        "RetryButton": "மீண்டும் முயற்சிக்கவும்",
        "PaymentSuccessTitle": "பணம் செலுத்தல் வெற்றி!",
        "PaymentSuccessMessage": "உங்கள் ஆர்டர் வெற்றிகரமாக இடம் பெற்றது.",
        "GoToCoursesButton": "படித்த படிப்புகளுக்கு செல்லவும்",
        "Payment": "பணம்",
        "TotalAmount": "மொத்த தொகை",
        "NoPaymentHistory": "பணம் செலுத்திய வரலாறு இல்லை",
        "TransactionId": "பரிவர்த்தனை ஐடி",
        "Amount": "தொகை",
        "Type": "பிரிவு",
        "Date": "தேதி",
        "ViewCourse": "படிப்பை பார்வையிடவும்",
        "SubmitSupportTicket": "ஆதரவு டிக்கெட் சமர்ப்பி",
        "Subject": "பொருள்",
        "SubmitTicket": "டிக்கெட் சமர்ப்பி",
        "YourSupportTickets": "உங்கள் ஆதரவு டிக்கெட்கள்",
        "NoTicketsFound": "எவ்வித டிக்கெட்களும் இல்லை.",
        "Previous": "முன்னொரு",
        "Next": "அடுத்தது",
        "Page": "பக்கம்",
        "Resolved": "பதிவேற்றப்பட்டு ✔️",
        "Pending": "காத்திருக்கிறது ⌛",
        "Resolution": "தீர்வு",
        "Start Course": "பாடத்தை தொடங்கவும்",
        "AboutTheCertificate": "சான்றிதழின் பற்றி",
        "AfterCompletingCourse": "பாடத்தை முடித்த பிறகு, உங்களுக்கு ஒரு டிஜிட்டல் சான்றிதழ் கிடைக்கும்.",
        "HowToGetIt": "இதனை எவ்வாறு பெறுவது",
        "EnrollInCourse": "ஏதேனும் ஒரு பாடத்தில் சேரவும். முடிக்கப்பட்டபின், ஒரு QR குறியீட்டுடன் சான்றிதழ் கிடைக்கும். அந்த QR குறியீட்டை ஸ்கேன் செய்தால், அது Skillz Verse செயலியில் செல்லும், அங்கு உங்கள் சான்றிதழை பார்க்க முடியும்.",
        "DigitalFormat": "டிஜிட்டல் வடிவம்",
        "CertificateInPdfFormat": "சான்றிதழ் PDF வடிவத்தில் கிடைக்கின்றது, மற்றும் உருவாக்கப்பட்ட பிறகு அதை எளிதாக பதிவிறக்கம் செய்யலாம்.",
        "WhyItIsImportant": "இதன் முக்கியத்துவம்",
        "ImportanceOfCertificate": "இந்த சான்றிதழ் உங்கள் ரிசுமேவை மேம்படுத்த, உங்கள் தொழில் வாய்ப்புகளை அதிகரிக்க, மற்றும் உங்கள் திறன்களையும் அறிவையும் அங்கீகரிக்க உதவலாம்.",
        "SampleCertificate": "எடுத்துக்காட்டுப் சான்றிதழ்",
        "CertificatePDF": "சான்றிதழ் PDF வடிவில் கிடைக்கின்றது, மேலும் அதை நீங்கள் எளிதாக பதிவிறக்கம் செய்யலாம்.",
        "CertificateImportance": "இந்த சான்றிதழ் உங்கள் ரிசுமேவை மேம்படுத்த, உங்கள் தொழில் வாய்ப்புகளை அதிகரிக்க, மற்றும் உங்கள் திறன்களையும் அறிவையும் அங்கீகரிக்க உதவலாம்.",
        "UponCompletion": "குறிப்பிட்ட பாடத்தை முடித்த பிறகு, நீங்கள் ஒரு டிஜிட்டல் சான்றிதழைப் பெறுவீர்கள்.",
        "WhyImportant": "இந்த சான்றிதழ் ஏன் முக்கியம்?",
        "Terms & Conditions": "நிபந்தனிகள்",
        RefundPolicy: "ரிஃபண்ட் கொள்கை",
        "Most Advanced Courses": "மிகவும் முன்னணி கோடுகள்",
        "Students": "மாணவர்கள்",
        "Loading cart, please wait...": "கரடுக்களை ஏற்றுகிறது, தயவுசெய்து காத்திருங்கள்...",
        "YOUR BAG IS EMPTY": "உங்கள் பை காலியாக உள்ளது",
        "There is nothing in your bag.": "உங்கள் பையில் எதுவும் இல்லை",
        "Let's add something new to your collection": "உங்கள் சேகரிப்பில் புதியதை சேர்க்கலாம்",
        "No items in the cart": "கர்டில் எந்த பொருட்களும் இல்லை",
        "Invalid course data": "தவறான பாடம் தரவு",
        "Let’s Make Payment": "செலுத்துவோம்",
        "Or login with": "அல்லது இதன் மூலம் உள்நுழைக",
        "Don’t have an account?": "கணக்கு இல்லையா?",
        "I agree to the": "நான் ஏற்கின்றேன்",
        "Create account": "கணக்கு உருவாக்கவும்",
        "Login to access your skillzverse account": "உங்கள் ஸ்கில்ஸ்வர்ஸ் கணக்கிற்கான உள்நுழைவிற்கு",
        "Sign up": "பதிவு செய்",
        "Let’s get everything set up so you can access your personal account": "நாம் எல்லாவற்றையும் அமைத்து உங்கள் தனிப்பட்ட கணக்கில் உள்நுழையலாம்",
        "Already have an account?": "இருந்தாலும் கணக்கு உள்ளதா?",
        "Or Sign up with": "அல்லது இதில் பதிவு செய்யவும்",
        "Log In": "உள்நுழைவு",
        "Password": "கடவுச்சொல்",
        "Full Name": "முழு பெயர்",
        "Forgot your password?": "உங்கள் கடவுச்சொலை மறந்துவிட்டீர்களா?",
        "Or Sign in with": "அல்லது இதன் மூலம் உள்நுழைக",
        "Submit": "சமர்ப்பி",
        "Set password": "கடவுச்சொலை அமைக்கவும்",
        "OTP": "ஒடிடிபி",
        "Enter your email below to recover your password": "உங்கள் கடவுச்சொல்லை மீட்டெடுக்க கீழே உங்கள் மின்னஞ்சலை உள்ளிடவும்",
        "Reset Password": "கடவுச்சொல்லை மீட்டமைக்கவும்",
        "Please create a new password for your account.": "உங்கள் கணக்குக்கு புதிய கடவுச்சொல்லை உருவாக்கவும்",
        "Back to login": "உள்நுழைவுக்கு மீண்டும் செல்லவும்",
        "Forgot Password": "கடவுச்சொல் மறந்துவிட்டீர்களா?",
        "Complete your learning journey—secure your spot now with a quick payment! Click below to proceed and unlock your next step to success.": "உங்கள் கற்றல் பயணத்தை முடிக்கவும்—ஒரு விரைவான கட்டணத்துடன் உங்கள் இடத்தை எப்போது உறுதி செய்யுங்கள்! தொடரவும் மற்றும் வெற்றிக்கான அடுத்த படியை திறக்க கீழே கிளிக் செய்யவும்.",

        "Phone number": "தொலைபேசி எண்",
        "Email or phone": "மின்னஞ்சல் அல்லது தொலைபேசி எண்",
        "Login with Password": "பாஸ்வேர்டுடன் உள்நுழைக",
        "Login with OTP": "ஓடிபி மூலம் உள்நுழைக",
        "Send OTP": "ஓடிபி அனுப்பவும்",
        "Submit OTP": "ஓடிபி சமர்ப்பிக்கவும்",
        "Enter OTP": "ஓடிபி பதிவு செய்யவும்",
        "NoCoursesCompleted": "நீங்கள் இன்னும் எந்தக் கோர்ஸையும் முடித்துவிடவில்லை.",
        "AI Interview": "AI நேர்முகம்",

      }
    }
    ,
    kn: {
      "translation": {
        "Courses": "ಕೋರ್ಸ್‌ಗಳು",
        "MyCourses": "ನನ್ನ ಕೋರ್ಸ್‌ಗಳು",
        "Categories": "ವರ್ಗಗಳು",
        "Instructor": "ಶಿಕ್ಷಕ",
        "SearchHere": "ಇಲ್ಲಿ ಹುಡುಕಿ...",
        "MainQuote": "ಪ್ರತಿದಿನವೂ ಮತ್ತು ಹೊಸ ಕೌಶಲ್ಯಗಳನ್ನು ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ಕಲಿಯಿರಿ.",
        "SubQuote": "ನಾವು ನಿಮ್ಮ ಕೈಯಲ್ಲಿ ಗುಣಮಟ್ಟದ ಶಿಕ್ಷಣವನ್ನು ಹೆಮ್ಮೆಪಡುವೆವು.",
        "StartLearning": "ಕಲಿಯಲು ಪ್ರಾರಂಭಿಸಿ",
        "ExploringSkills": "ಇಲ್ಲಿ ನಿಮ್ಮ ಕೌಶಲ್ಯಗಳನ್ನು ಅನ್ವೇಷಿಸು.",
        "ChoosePlatform": "ನಮ್ಮ ವೇದಿಕೆಯನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
        "FeaturedCourses": "ಪ್ರಮುಖ ಕೋರ್ಸ್‌ಗಳು",
        "PreviousSearchedCourses": "ಹಿಂದಿನ ಹುಡುಕಿದ ಕೋರ್ಸ್‌ಗಳು",
        "ExploreMore": "ಹೆಚ್ಚು ಅನ್ವೇಷಿಸಿ",
        "ExploreLess": "ಕಿಮ್ಮತ್ತು ಅನ್ವೇಷಿಸಿ",
        "Save": "ಸೇವ್",
        "FullName": "ಪೂರ್ಣ ಹೆಸರು",
        "Email": "ಇಮೇಲ್",
        "NewEmail": "ಹೊಸ ಇಮೇಲ್",
        "Home": "ಮನೆ",
        "Instructors": "ಶಿಕ್ಷಕರನ್ನು",
        "AboutUs": "ನಮ್ಮ ಬಗ್ಗೆ",
        "ContactUs": "ಕೊಂಟ್ಕರಲು",
        "Teams": "ತಂಡಗಳು",
        "PrivacyPolicy": "ಗೋಪ್ಯತಾ ನೀತಿ",
        "CookingSettings": "ಅಡುಗೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
        "SiteMap": "ಸೈಟ್ ನಕ್ಷೆ",
        "NoResultsFound": "ಯಾವುದೇ ಫಲಿತಾಂಶಗಳು ಸಿಕ್ಕಿಲ್ಲ",
        "GoToMyCourses": "ನನ್ನ ಕೋರ್ಸ್‌ಗಳಿಗೆ ಹೋಗಿ",
        "NoCoursesEnrolled": "ಯಾವುದೇ ಕೋರ್ಸ್‌ಗಳು ನೋಂದಾಯಿಸಲಾಗಿಲ್ಲ",
        "AccountSettings": "ಖಾತೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
        "Signout": "ಸೈನ್ ಔಟ್",
        "EnrolledCourses": "ನೋಂದಾಯಿತ ಕೋರ್ಸ್‌ಗಳು",
        "PersonalInfo": "ವ್ಯಕ್ತಿಗತ ಮಾಹಿತಿ",
        "AccountSecurity": "ಖಾತೆ ಭದ್ರತೆ",
        "CompletedCourses": "ಪೂರ್ಣವಾದ ಕೋರ್ಸ್‌ಗಳು",
        "Wishlist": "ಕಾಮನಾಕ್ಷ",
        "PaymentHistory": "ಪಾವತಿ ಇತಿಹಾಸ",
        "CurrentPassword": "ಪ್ರಸ್ತುತ ಪಾಸ್ವರ್ಡ್",
        "NewPassword": "ಹೊಸ ಪಾಸ್ವರ್ಡ್",
        "ReTypeNewPassword": "ಹೊಸ ಪಾಸ್ವರ್ಡ್ ಪುನಃ ಟೈಪ್ ಮಾಡಿ",
        "MobileAppAuthenticator": "ಮೊಬೈಲ್ ಅಪ್ಲಿಕೇಶನ್ ದೃಢೀಕರಿಸುವುದು",
        "UseMobileApp": "ವೆರಿಫಿಕೇಶನ್ ಕೋಡ್‌ಗಳಿಗೆ ಮೊಬೈಲ್ ಅಪ್ಲಿಕೇಶನ್ ಬಳಸಿರಿ.",
        "ReceiveVerificationCode": "ಇಮೇಲ್ ಮೂಲಕ ದೃಢೀಕರಣ ಕೋಡ್ ಸ್ವೀಕರಿಸಿ.",
        "Continue": "ಮುಂದುವರಿಯಿರಿ",
        "PasswordUpdate": "ಪಾಸ್ವರ್ಡ್ ಅಪ್ಡೇಟ್",
        "TwoFASettings": "2FA ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
        "AccountActivityLog": "ಖಾತೆ ಚಲನೆ ಲಾಗ್",
        "CourseManagement": "ಕೋರ್ಸ್ ನಿರ್ವಹಣೆ",
        "StudentAnalytics": "ಶಿಕ್ಷಕ ವಿಶ್ಲೇಷಣೆ",
        "EarningsOverview": "ಆಯನ ಸಮೀಕ್ಷೆ",
        "CourseReviews": "ಕೋರ್ಸ್ ವಿಮರ್ಶೆಗಳು",
        "Announcements": "ಜಾಹೀರಾತುಗಳು",
        "SelectASection": "ಒಂದು ವಿಭಾಗವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
        "NewCourse": "+ ಹೊಸ ಕೋರ್ಸ್",
        "CourseName": "ಕೋರ್ಸ್ ಹೆಸರು",
        "Welcome back": "ಮತ್ತೆ ಸ್ವಾಗತ",
        "Description": "ವಿವರಣೆ",
        "Price": "ಬೆಲೆ",
        "Action": "ಕ್ರಿಯೆ",
        "Earnings": "ಆಯ",
        "TrackYourEarnings": "ನಿಮ್ಮ ಆದಾಯ ಮತ್ತು ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಇಲ್ಲಿ ಹಂಚಿಕೊಳ್ಳಿ.",
        "HideReport": "ರಿಪೋರ್ಟ್ ಅಡಗಿಸಿ",
        "ViewReport": "ರಿಪೋರ್ಟ್ ನೋಡಿ",
        "YourEarningsReport": "ನಿಮ್ಮ ಆದಾಯದ ವರದಿ",
        "TotalEarnings": "ಒಟ್ಟು ಆದಾಯ",
        "CoursesSold": "ಮಾರಾಟ ಮಾಡಿದ ಕೋರ್ಸ್‌ಗಳು",
        "LastPayout": "ಕಳೆದ ಪಾವತಿ",
        "NextPayout": "ಮರುಪಾವತಿ",
        "AddNewCourse": "ಹೊಸ ಕೋರ್ಸ್ ಸೇರಿಸಿ",
        "CourseAddedSuccess": "ಕೋರ್ಸ್ ಯಶಸ್ವಿಯಾಗಿ ಸೇರಿಸಲಾಗಿದೆ!",
        "CourseAddedFail": "ಕೋರ್ಸ್ ಸೇರಿಸಲು ವಿಫಲ.",
        "CourseAddError": "ಕೋರ್ಸ್ ಸೇರಿಸುವಾಗ ದೋಷ.",
        "SelectCategory": "ವರ್ಗ ಆಯ್ಕೆ ಮಾಡಿ",
        "SelectSubcategory": "ಉಪವರ್ಗ ಆಯ್ಕೆ ಮಾಡಿ",
        "SelectLevel": "ಮಟ್ಟ ಆಯ್ಕೆ ಮಾಡಿ",
        "SelectLanguage": "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ",
        "UploadThumbnail": "ಥಂಬ್ನೆಲ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
        "Section": "ಭಾಗ",
        "SectionTitle": "ಭಾಗದ ಶೀರ್ಷಿಕೆ",
        "VideoTitle": "ವಿಡಿಯೋ ಶೀರ್ಷಿಕೆ",
        "AddLesson": "ಪಾಠ ಸೇರಿಸಿ",
        "RemoveSection": "ಭಾಗವನ್ನು ತೆಗೆದುಹಾಕಿ",
        "AddAnotherSection": "ಇನ್ನೊಂದು ಭಾಗ ಸೇರಿಸಿ",
        "UploadingCourse": "ನಿಮ್ಮ ಕೋರ್ಸ್ ಅಪ್ಲೋಡ್ ಆಗುತ್ತಿದೆ. ದಯವಿಟ್ಟು ಕೆಲ ಕ್ಷಣ ಕಾಯಿರಿ... ",
        "QuizCreation": "ನೀವು ಕ್ವಿಜ್ ರಚಿಸಲು ಬಯಸುತ್ತೀರಾ?",
        "MostSearchedCourses": "ಎಷ್ಟು ಹೆಚ್ಚು ಹುಡುಕಲ್ಪಟ್ಟ ಕೋರ್ಸ್‌ಗಳು",
        "Message": "ಸಂದೇಶ",
        "SendMessage": "ಸಂದೇಶವನ್ನು ಕಳುಹಿಸಿ",
        "Cart": "ಕಾರ್ಟ್",
        "OrderSummary": "ಆರ್ಡರ್ ಸಂಗ್ರಹ",
        "Items": "ಐಟಂಗಳು",
        "OrderValue": "ಆರ್ಡರ್ ಮೌಲ್ಯ",
        "GrandTotal": "ಒಟ್ಟು ಮೊತ್ತ",
        "Checkout": "ಚೆಕ್‌ಔಟ್",
        "UploadingQuiz": "ಕ್ವಿಜ್ ಅಪ್ಲೋಡ್ ಆಗುತ್ತಿದೆ",
        "QuizAddedSuccess": "ಕ್ವಿಜ್ ಯಶಸ್ವಿಯಾಗಿ ಸೇರಿಸಲಾಗಿದೆ!",
        "QuizAddedFail": "ಕ್ವಿಜ್ ಸೇರಿಸಲು ವಿಫಲವಾಗಿದೆ.",
        "QuizAddError": "ಕ್ವಿಜ್ ಸೇರಿಸಲು ದೋಷವಾಗಿದೆ.",
        "AddNewQuiz": "ಹೊಸ ಕ್ವಿಜ್ ಸೇರಿಸಿ",
        "EnterYourQuestion": "ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ನಮೂದಿಸಿ",
        "Question": "ಪ್ರಶ್ನೆ",
        "Provide4AnswerOptions": "4 ಉತ್ತರ ಆಯ್ಕೆಗಳು ಒದಗಿಸಿ (ಒಬ್ಬನನ್ನು ಸರಿಯಾಗಿ ಆಯ್ಕೆ ಮಾಡಿ):",
        "Answer": "ಉತ್ತರ",
        "Correct": "ಸರಿಯಾದ",
        "RemoveQuestion": "ಪ್ರಶ್ನೆ ತೆಗೆದುಹಾಕಿ",
        "AddAnotherQuestion": "ಮರೆಗಿನ ಪ್ರಶ್ನೆ ಸೇರಿಸಿ",
        "AddQuiz": "ಕ್ವಿಜ್ ಸೇರಿಸಿ",
        "QuizUploadedSuccessfully": "ಕ್ವಿಜ್ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್ಲೋಡ್ ಆಗಿದೆ!",
        "DoYouWantToGoHomePage": "ನೀವು ಹೋಮ್ ಪೇಜ್‌ಗೆ ಹೋಗಲು ಬಯಸುತ್ತೀರಾ?",
        "GoHome": "ಹೋಮ್ ಪೇಜ್‌ಗೆ ಹೋಗಿ",
        "Language": "ಭಾಷೆ",
        "Level": "ಮಟ್ಟ",
        "PriceRange": "ಕಿಮತ್ ವ್ಯಾಪ್ತಿಗೆ",
        "Rating": "ರೆಟಿಂಗ್",
        "ShowLess": "ಕಿಂಚಿತ ತೋರಿಸಿ...",
        "ShowMore": "ಹೆಚ್ಚು ತೋರಿಸಿ...",
        "ClearFilters": "ಫಿಲ್ಟರ್‌ಗಳನ್ನು ಕ್ಲೀಯರ್ ಮಾಡಿ",
        "ApplyFilters": "ಫಿಲ್ಟರ್‌ಗಳನ್ನು ಅನ್ವಯಿಸಿ",
        "MinPrice": "ಕೀಳ್ಮಟ್ಟದ ಕಿಮತ್ತು",
        "MaxPrice": "ಅತಿಕಂಡ ಕಿಮತ್ತು",
        "Close": "ಮುಗಿಯಿರಿ",
        "SelectPriceRange": "ಒಂದು ಕಿಮತ್ ವ್ಯಾಪ್ತಿಯನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
        "SelectRating": "ಒಂದು ರೇಟಿಂಗ್ ಅನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
        "SearchResultsfor": "ಹುಡಿಕೆಗೆ ಫಲಿತಾಂಶಗಳು",
        "Total": "ಒಟ್ಟು",
        "Filters": "ಫಿಲ್ಟರ್‌ಗಳು",
        "Gotocart": "ಕಾರ್ಟ್‌ಗೆ ಹೋಗಿ",
        "languageCourse": "ಕನ್ನಡದಲ್ಲಿ ಕೋರ್ಸ್",
        "Login": "ಪ್ರವೇಶಿಸಿ",
        "Recommended Courses Based on Your Recent Completion: ": "ನಿಮ್ಮ ಇತ್ತೀಚಿನ ಪೂರ್ಣಗೊಂಡ ಕೋರ್ಸ್‌ಗಳ ಆಧಾರದ ಮೇಲೆ ಶಿಫಾರಸು ಮಾಡಿದ ಕೋರ್ಸ್‌ಗಳು: ",
        "Explore Courses Related to Your Recent Completion: ": "ನಿಮ್ಮ ಇತ್ತೀಚಿನ ಪೂರ್ಣಗೊಂಡ ಕೋರ್ಸ್‌ಗಳೊಂದಿಗೆ ಸಂಬಂಧಿಸಿದ ಕೋರ್ಸ್‌ಗಳನ್ನು ಅನ್ವೇಷಿಸಿ: ",
        "You May Like These Courses After Completing: ": "ನೀವು ಈ ಕೋರ್ಸ್ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ ನಂತರ ಇಷ್ಟಪಡಬಹುದು: ",
        "Discover New Courses Based on Your Recent Completion: ": "ನಿಮ್ಮ ಇತ್ತೀಚಿನ ಪೂರ್ಣಗೊಂಡ ಕೋರ್ಸ್‌ಗಳ ಆಧಾರದ ಮೇಲೆ ಹೊಸ ಕೋರ್ಸ್ಗಳನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ: ",
        "Courses Suggested After Your Recent Completion: ": "ನಿಮ್ಮ ಇತ್ತೀಚಿನ ಪೂರ್ಣಗೊಂಡ ಕೋರ್ಸ್‌ಗಳ ನಂತರ ಶಿಫಾರಸು ಮಾಡಿದ ಕೋರ್ಸ್‌ಗಳು: ",
        "CookieSettings": "ಕೂಕಿ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
        "English": "ಇಂಗ್ಲಿಷ್",
        "Recently Completed Courses": "ಇತ್ತೀಚೆಗೆ ಪೂರ್ಣಗೊಳಿಸಿದ ಕೋರ್ಸ್‌ಗಳು",
        "HelpMessage": "ನಾವು ನಿಮ್ಮ ಸಹಾಯಕ್ಕಾಗಿ ಇಲ್ಲಿದ್ದೇವೆ! ನಾವು ಹೇಗೆ ಸಹಾಯ ಮಾಡಬಹುದು?",
        "SubjectPlaceholder": "ವಿಷಯ (ಸಮಸ್ಯೆ)",
        "DescriptionPlaceholder": "ವಿವರಣೆ",
        "SubmitButton": "ಟಿಕೇಟ್ ಸಲ್ಲಿಸಿ",
        "PaymentFailedTitle": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ",
        "PaymentFailedMessage": "ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
        "RetryButton": "ಪುನಃ ಪ್ರಯತ್ನಿಸಿ",
        "PaymentSuccessTitle": "ಪಾವತಿ ಯಶಸ್ವಿ!",
        "PaymentSuccessMessage": "ನಿಮ್ಮ ಆದೇಶ ಯಶಸ್ವಿಯಾಗಿ ನಿರ್ವಹಿಸಲಾಗಿದೆ.",
        "GoToCoursesButton": "ನೋಂದಣಿ ಮಾಡಿದ ಕೋರ್ಸ್‌ಗಳಿಗೆ ಹೋಗಿ",
        "Payment": "ಪಾವತಿ",
        "TotalAmount": "ಒಟ್ಟು ಮೊತ್ತ",
        "NoPaymentHistory": "ಪಾವತಿ ಇತಿಹಾಸವಿಲ್ಲ",
        "TransactionId": "ವಹಿವಾಟು ಐಡಿ",
        "Amount": "ಮೊತ್ತ",
        "Type": "ಪ್ರಕಾರ",
        "Date": "ದಿನಾಂಕ",
        "ViewCourse": "ಕೋರ್ಸ್ ಅನ್ನು ವೀಕ್ಷಿಸಿ",
        "SubmitSupportTicket": "ಸಹಾಯ ಟಿಕೇಟ್ ಸಲ್ಲಿಸಿ",
        "Subject": "ವಿಷಯ",
        "SubmitTicket": "ಟಿಕೇಟ್ ಸಲ್ಲಿಸಿ",
        "YourSupportTickets": "ನಿಮ್ಮ ಸಹಾಯ ಟಿಕೇಟ್‌ಗಳು",
        "NoTicketsFound": "ಯಾವುದೇ ಟಿಕೇಟ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
        "Previous": "ಮೂಡಲಾದ",
        "Next": "ಮುಂದೆ",
        "Page": "ಪುಟ",
        "Resolved": "ಪರಿಶೀಲಿಸಲ್ಪಟ್ಟ ✔️",
        "Pending": "ಬಾಕಿ ⌛",
        "Resolution": "ನಿರಾಕರಣ",
        "Start Course": "ಕೋರ್ಸ್ ಪ್ರಾರಂಭಿಸಿ",
        "AboutTheCertificate": "ಸான்றಪತ್ರದ ಕುರಿತು",
        "AfterCompletingCourse": "ಕೋರ್ಸ್ ಪೂರ್ಣಗೊಳಿಸಿದ ನಂತರ, ನಿಮಗೆ ಡಿಜಿಟಲ್ ಪ್ರಮಾಣಪತ್ರವು ನೀಡಲಾಗುತ್ತದೆ.",
        "HowToGetIt": "ಅದರನ್ನು ಹೇಗೆ ಪಡೆಯುವುದು",
        "EnrollInCourse": "ಯಾವುದೇ ಕೋರ್ಸ್‌ನಲ್ಲಿ ನೋಂದಣಿ ಮಾಡಿರಿ. ಪೂರ್ಣಗೊಳಿಸಿದ ನಂತರ, ಅದರಲ್ಲಿ ಒಂದು QR ಕೋಡ್‌ ಇರುವ ಪ್ರಮಾಣಪತ್ರವನ್ನು ಪಡೆಯುತ್ತೀರಿ. ಅದನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿದರೆ, ಅದು Skillz Verse ಅಪ್ಲಿಕೇಶನ್‌ಗೆ ಮರುನಿರ್ದೇಶಿಸುತ್ತದೆ, ಅಲ್ಲಿ ನಿಮ್ಮ ಪ್ರಮಾಣಪತ್ರವನ್ನು ವೀಕ್ಷಿಸಬಹುದು.",
        "DigitalFormat": "ಡಿಜಿಟಲ್ ಪ್ರಬಂಧ",
        "CertificateInPdfFormat": "ಪ್ರಮಾಣಪತ್ರವು PDF ಪ್ರಾತಿ ರೂಪದಲ್ಲಿ ಲಭ್ಯವಿದೆ, ಮತ್ತು ಅದು ರಚನೆಯಾದ ನಂತರ ನೀವು ಅದನ್ನು ಸುಲಭವಾಗಿ ಡೌನ್ಲೋಡ್ ಮಾಡಬಹುದು.",
        "WhyItIsImportant": "ಇದು ಎಂತಹ ಮಹತ್ವಪೂರ್ಣವೋ",
        "ImportanceOfCertificate": "ಈ ಪ್ರಮಾಣಪತ್ರವು ನಿಮ್ಮ ರಿಜ್ಯೂಮೆ ಅನ್ನು ಉತ್ತೇಜಿಸಲು, ನಿಮ್ಮ ಉದ್ಯೋಗ ಅವಕಾಶಗಳನ್ನು ಉತ್ತಮಗೊಳಿಸಲು ಮತ್ತು ನಿಮ್ಮ ಕೌಶಲ್ಯಗಳು ಮತ್ತು ಜ್ಞಾನವನ್ನು ಒಪ್ಪಿಗೆಯಾಗಿ ಒದಗಿಸಬಹುದು.",
        "SampleCertificate": "ಮಾದರಿ ಪ್ರಮಾಣಪತ್ರ",
        "CertificatePDF": "ಪ್ರಮಾಣಪತ್ರವು PDF ರೂಪದಲ್ಲಿ ಲಭ್ಯವಿದೆ, ಮತ್ತು ನೀವು ಅದನ್ನು ಸುಲಭವಾಗಿ ಡೌನ್ಲೋಡ್ ಮಾಡಬಹುದು.",
        "CertificateImportance": "ಈ ಪ್ರಮಾಣಪತ್ರವು ನಿಮ್ಮ ರಿಜ್ಯೂಮೆ ಅನ್ನು ಉತ್ತೇಜಿಸಲು, ನಿಮ್ಮ ಉದ್ಯೋಗ ಅವಕಾಶಗಳನ್ನು ಉತ್ತಮಗೊಳಿಸಲು ಮತ್ತು ನಿಮ್ಮ ಕೌಶಲ್ಯಗಳು ಮತ್ತು ಜ್ಞಾನವನ್ನು ಒಪ್ಪಿಗೆಯಾಗಿ ಒದಗಿಸಬಹುದು.",
        "UponCompletion": "ಪಾಠವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ ನಂತರ, ನೀವು ಡಿಜಿಟಲ್ ಪ್ರಮಾಣಪತ್ರವನ್ನು ಪಡೆಯುವಿರಿ.",
        "WhyImportant": "ಈ ಪ್ರಮಾಣಪತ್ರವು ಏಕೆ ಮುಖ್ಯವಾದದ್ದು?",
        "Terms & Conditions": "ನಿಬಂಧನೆಗಳು",
        RefundPolicy: "ರಿಫಂಡ್ ನೀತಿ",
        "Most Advanced Courses": "ಅತ್ಯಂತ ಮುಂದುವರೆದ ಕೋರ್ಸ್‌ಗಳು",
        "Students": "ವಿದ್ಯಾರ್ಥಿಗಳು",
        "Loading cart, please wait...": "ಕಾರು ಲೋಡ್ ಆಗುತ್ತಿದೆ, ದಯವಿಟ್ಟು ಕಾಯಿರಿ...",
        "YOUR BAG IS EMPTY": "ನಿಮ್ಮ ಬ್ಯಾಗ್ ಖಾಲಿ ಇದೆ",
        "There is nothing in your bag.": "ನಿಮ್ಮ ಬ್ಯಾಗ್ನಲ್ಲಿ ಏನು ಇಲ್ಲ",
        "Let's add something new to your collection": "ನಿಮ್ಮ ಸಂಗ್ರಹಕ್ಕೆ ಹೊಸದನ್ನು ಸೇರಿಸೋಣ",
        "No items in the cart": "ಕಾರುನಲ್ಲಿ ಯಾವುದೇ ಐಟಂಗಳು ಇಲ್ಲ",
        "Invalid course data": "ಅಮಾನ್ಯ ಕೋರ್ಸ್ ಡೇಟಾ",
        "Let’s Make Payment": "ಚೆಲ್ಲಿಸಿ ಪಾವತಿ ಮಾಡಿ",
        "Or login with": "ಅಥವಾ ಲಾಗಿನ್ ಮಾಡಿ",
        "Don’t have an account?": "ನಿಮ್ಮಲ್ಲಿ ಖಾತೆ ಇಲ್ಲವೇ?",
        "I agree to the": "ನಾನು ಒಪ್ಪಿಗೆಯಾದೆನೆ",
        "Create account": "ಖಾತೆ ರಚಿಸಿ",
        "Login to access your skillzverse account": "ನಿಮ್ಮ skillzverse ಖಾತೆಗೆ ಪ್ರವೇಶ ಮಾಡಲು ಲಾಗಿನ್ ಮಾಡಿ",
        "Sign up": "ಸೈನ್ ಅಪ್",
        "Let’s get everything set up so you can access your personal account": "ನಾವು ಎಲ್ಲವೂ ಸಿದ್ಧಪಡಿಸೋಣ যাতে ನೀವು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಖಾತೆಗೆ ಪ್ರವೇಶಿಸಬಹುದು",
        "Already have an account?": "ಹೆಚ್ಚು ಖಾತೆ ಇದೆ?",
        "Or Sign up with": "ಅಥವಾ ಸೈನ್ ಅಪ್ ಮಾಡಿ",
        "Log In": "ಲಾಗಿನ್",
        "Password": "ಪಾಸ್ವರ್ಡ್",
        "Full Name": "ಪೂರ್ಣ ಹೆಸರು",
        "Forgot your password?": "ನೀವು ನಿಮ್ಮ ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ಮರೆತಿದ್ದೀರಾ?",
        "Or Sign in with": "ಅಥವಾ ಸೈನ್ ಇನ್ ಮಾಡಿ",
        "Submit": "ಸಮರ್ಪಿಸಿ",
        "Set password": "ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ಸೆಟ್ ಮಾಡಿ",
        "OTP": "ಒಟಿಪಿ",
        "Enter your email below to recover your password": "ನಿಮ್ಮ ಪಾಸ್ವರ್ಡ್ ಪುನಃ ಪಡೆದುಕೊಳ್ಳಲು ಕೆಳಗಿನ ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ",
        "Reset Password": "ಪಾಸ್ವರ್ಡ್ ಪುನಃ ಸೆಟ್ ಮಾಡಿ",
        "Please create a new password for your account.": "ನಿಮ್ಮ ಖಾತೆಗೆ ಹೊಸ ಪಾಸ್ವರ್ಡ್ ರಚಿಸಿ",
        "Back to login": "ಲಾಗಿನ್‌ಗೆ ಹಿಂತಿರುಗಿ",
        "Forgot Password": "ನೀವು ನಿಮ್ಮ ಪಾಸ್ವರ್ಡ್ ಮರೆತಿದ್ದೀರಾ?",
        "Complete your learning journey—secure your spot now with a quick payment! Click below to proceed and unlock your next step to success.": "ನಿಮ್ಮ ಕಲಿಕೆಯ ಪ್ರಯಾಣವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ—ಒಂದು ತ್ವರಿತ ಪಾವತಿಯೊಂದಿಗೆ ನಿಮ್ಮ ಸ್ಥಾನವನ್ನು ಈಗಲೇ ಭದ್ರಪಡಿಸಿ! ಮುಂದುವರಿಯಲು ಕೆಳಗೆ ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ಯಶಸ್ಸುಗಾಗಿ ನಿಮ್ಮ ಮುಂದಿನ ಹೆಜ್ಜೆಯನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಿ.",
        "Email or phone": "ಇಮೇಲ್ ಅಥವಾ ಫೋನ್ ನಂಬರ್",
        "Phone number": "ಫೋನ್ ನಂಬರ್",

        "Login with Password": "ಪಾಸ್ವರ್ಡ್‌తో ಲಾಗಿನ್ ಮಾಡಿ",
        "Login with OTP": "ಒಟಿಪಿ ಮೂಲಕ ಲಾಗಿನ್ ಮಾಡಿ",
        "Send OTP": "ಒಟಿಪಿ ಕಳುಹಿಸಿ",
        "Submit OTP": "ಒಟಿಪಿ ಸಲ್ಲಿಸಿ",
        "Enter OTP": "ಒಟಿಪಿ ನಮೂದಿಸಿ",
        "NoCoursesCompleted": "ನೀವು ಇನ್ನು ಯಾವ ಕೋರ್ಸ್ ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸಿಲ್ಲ.",
        "AI Interview": "AI ಸಂದರ್ಶನ"

      }
    }
  }
});